<script setup lang="ts">
  import { ref, onMounted, computed } from "vue";
  import { useDisplay } from "vuetify";
  import { useRoute } from "vue-router";
  import Sidebar from "~/components/layoutComponents/sidebar/Sidebar.vue";
  import Header from "~/components/layoutComponents/header/Header.vue";

  // This is the default layout for the admin panel
  const drawer = ref(undefined || true);
  const route = useRoute();
  const innerW = window.innerWidth;
  const { mdAndUp, mdAndDown } = useDisplay();
  const isFullWidthPage = computed(() => String(route.path || '').startsWith('/rentals-v2'));
  // Automatically close the drawer on mobile devices
  onMounted(() => {
    if (innerW < 950) {
      drawer.value = !drawer.value;
    }
  });
</script>
<template>
  <div>
    <v-app>
      <!-- ---------------------------------------------- -->
      <!---Header -->
      <!-- ---------------------------------------------- -->
      <v-app-bar elevation="0" color="primary">
        <div class="pe-5">
          <v-container class="fill-height">
            <v-row justify="center" align="center">
                <v-col cols="auto" class="d-flex align-center">
                    <img src="/images/logos/ikon.svg" lass="white-logo" width="60" height="60"/>
                    <span class="pt-1 header-text align-self-center">ADMIN</span>
                </v-col>
            </v-row>
          </v-container>
        </div>
        <v-app-bar-nav-icon class="" @click="drawer = !drawer" />
        <v-spacer />
        <!-- ---------------------------------------------- -->
        <!-- User Profile -->
        <!-- ---------------------------------------------- -->
        <Header />
      </v-app-bar>
      <v-main>
        <!-- ---------------------------------------------- -->
        <!---Sidebar -->
        <!-- ---------------------------------------------- -->
        <v-navigation-drawer
          left
          :permanent="mdAndUp"
          elevation="10"
          app
          :temporary="mdAndDown"
          v-model="drawer"
          expand-on-hover
        >
          <Sidebar />
        </v-navigation-drawer>
        <v-container fluid :class="['page-wrapper', { 'page-wrapper--full': isFullWidthPage }]">
          <slot />
        </v-container>
      </v-main>
    </v-app>
  </div>
</template>
<style>
  .header-text {
    font-family: 'Montserrat', sans-serif;
    font-weight: bold;
    font-size: 20px;
    color: #3B4270;
  } 
</style>

